enum AttachmentStatus {
	Undefined = 0,
	Submitted = 1,
	Approved = 2,
	Rejected = 3,
	AboutToExpire = 4,
	Expired = 5
}

export default AttachmentStatus;
